import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-679fedb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom-global-skeleton tw-bg-[#ffffff] tw-min-w-[284px] tw-max-w-[284px] tw-h-[112px] tw-w-full tw-flex tw-flex-col tw-justify-between tw-items-start tw-flex-[1_0_0] tw-self-stretch tw-border tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] tw-p-5 tw-rounded-[6px] tw-border-solid tw-border-[#EFF0F1]" }

import {} from "@/services/apiRoutes/routes";

export default /*#__PURE__*/_defineComponent({
  __name: 'contributorsCardSkeleton',
  props: {
  title: { type: String, default: "Contributors" },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1))
}
}

})